import React from "react";

const CashFlowTable = ({ ccf, operating, credit, inv, cf }) => {
  if (!operating || !credit || !inv || !cf || !ccf) {
    return (
      <div className="table-container">
        Данные для отображения ДДС временно недоступны.
      </div>
    );
  }

  const formatNumber = (value) => {
    if (value === undefined || value === null) return "0";
    return Math.round(value).toLocaleString("ru-RU");
  };

  const negativeClass = (value) => (value < 0 ? "red" : "");

  // Обычные операционные строки
  const sections = [
    operating.cards,
    operating.coachs,
    operating.rentIn,
    operating.otherIn,
    operating.rentOut,
    operating.fot,
    operating.utility,
    operating.payback,
    operating.cleaning,
    operating.marketing,
    operating.acquiring,
    operating.exploitation,
    operating.simulatorRepairs,
    operating.it,
    operating.crm,
    operating.bank,
    operating.staff,
    operating.household,
    operating.plastic,
    operating.copyright,
    operating.insurance,
    operating.other,
    operating.taxes,
  ];

  return (
    <div className="table-container">
      <table className="table" id="cashFlow">
        <caption className="table-caption">
          Прогноз движения денежных средств
        </caption>
        <thead>
          <tr>
            <th>Наименование</th>
            <th>инвест</th>
            <th>1-й год</th>
            <th>2-й год</th>
            <th>3-й год</th>
            <th>4-й год</th>
            <th>5-й год</th>
            <th>6-й год</th>
            <th>7-й год</th>
          </tr>
        </thead>
        <tbody>
          {sections.map((section, idx) => {
            if (!section || !section[0]) return null;
            const [data, name] = section;
            return (
              <tr key={idx}>
                <td className="table-fields__name">{name || "—"}</td>
                {[0, 1, 2, 3, 4, 5, 6, 7].map((year) => (
                  <td
                    key={year}
                    className={`cell ${negativeClass(data?.[year] || 0)}`}
                  >
                    {formatNumber(data?.[year] || 0)}
                  </td>
                ))}
              </tr>
            );
          })}

          {/* ЧДП от операционной деятельности */}
          {operating.ccFOA && (
            <tr>
              <td className="table-fields__name cell__total">
                {operating.ccFOA[1]}
              </td>
              {[0, 1, 2, 3, 4, 5, 6, 7].map((year) => (
                <td
                  key={year}
                  className={`cell cell__total ${negativeClass(operating.ccFOA[0]?.[year] || 0)}`}
                >
                  {formatNumber(operating.ccFOA[0]?.[year] || 0)}
                </td>
              ))}
            </tr>
          )}

          {/* Взнос Собственника */}
          {credit.ownerIn && (
            <tr>
              <td className="table-fields__name">{credit.ownerIn[1]}</td>
              {[0, 1, 2, 3, 4, 5, 6, 7].map((year) => (
                <td
                  key={year}
                  className={`cell ${negativeClass(credit.ownerIn[0]?.[year] || 0)}`}
                >
                  {formatNumber(credit.ownerIn[0]?.[year] || 0)}
                </td>
              ))}
            </tr>
          )}

          {/* Сумма кредита */}
          {credit.dutyIn && (
            <tr>
              <td className="table-fields__name">{credit.dutyIn[1]}</td>
              {[0, 1, 2, 3, 4, 5, 6, 7].map((year) => (
                <td
                  key={year}
                  className={`cell ${negativeClass(credit.dutyIn[0]?.[year] || 0)}`}
                >
                  {formatNumber(credit.dutyIn[0]?.[year] || 0)}
                </td>
              ))}
            </tr>
          )}

          {/* Выплаты тела долга */}
          {credit.dutyOut && (
            <tr>
              <td className="table-fields__name">{credit.dutyOut[1]}</td>
              {[0, 1, 2, 3, 4, 5, 6, 7].map((year) => (
                <td
                  key={year}
                  className={`cell ${negativeClass(credit.dutyOut[0]?.[year] || 0)}`}
                >
                  {formatNumber(credit.dutyOut[0]?.[year] || 0)}
                </td>
              ))}
            </tr>
          )}

          {/* Выплаты процентов */}
          {credit.interestOut && (
            <tr>
              <td className="table-fields__name">{credit.interestOut[1]}</td>
              {[0, 1, 2, 3, 4, 5, 6, 7].map((year) => (
                <td
                  key={year}
                  className={`cell ${negativeClass(credit.interestOut[0]?.[year] || 0)}`}
                >
                  {formatNumber(credit.interestOut[0]?.[year] || 0)}
                </td>
              ))}
            </tr>
          )}

          {/* ЧДП от финансовой деятельности */}
          {credit.cfFinance && (
            <tr>
              <td className="table-fields__name cell__total">
                {credit.cfFinance[1]}
              </td>
              {[0, 1, 2, 3, 4, 5, 6, 7].map((year) => (
                <td
                  key={year}
                  className={`cell cell__total ${negativeClass(credit.cfFinance[0]?.[year] || 0)}`}
                >
                  {formatNumber(credit.cfFinance[0]?.[year] || 0)}
                </td>
              ))}
            </tr>
          )}

          {/* ЧДП от инвестиционной деятельности */}
          {inv.cfInv && (
            <tr>
              <td className="table-fields__name cell__total">{inv.cfInv[1]}</td>
              {[0, 1, 2, 3, 4, 5, 6, 7].map((year) => (
                <td
                  key={year}
                  className={`cell cell__total ${negativeClass(inv.cfInv[0]?.[year] || 0)}`}
                >
                  {formatNumber(inv.cfInv[0]?.[year] || 0)}
                </td>
              ))}
            </tr>
          )}

          {/* Итоговый денежный поток */}
          {cf.cf && (
            <tr>
              <td className="table-fields__name cell__total">{cf.cf[1]}</td>
              {[0, 1, 2, 3, 4, 5, 6, 7].map((year) => (
                <td
                  key={year}
                  className={`cell cell__total ${negativeClass(cf.cf[0]?.[year] || 0)}`}
                >
                  {formatNumber(cf.cf[0]?.[year] || 0)}
                </td>
              ))}
            </tr>
          )}

          {/* Накопленный денежный поток */}
          {ccf.ccf && (
            <tr>
              <td className="table-fields__name cell__total">{ccf.ccf[1]}</td>
              {[0, 1, 2, 3, 4, 5, 6, 7].map((year) => (
                <td
                  key={year}
                  className={`cell cell__total ${negativeClass(ccf.ccf[0]?.[year] || 0)}`}
                >
                  {formatNumber(ccf.ccf[0]?.[year] || 0)}
                </td>
              ))}
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default CashFlowTable;
